/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Companydetails_Address1Inputs */

const ja_company_companydetails_address1 = /** @type {(inputs: Company_Companydetails_Address1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`〒141-0031`)
};

const en_company_companydetails_address1 = /** @type {(inputs: Company_Companydetails_Address1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7-22-17 Nishigotanda`)
};

/**
* | output |
* | --- |
* | "7-22-17 Nishigotanda" |
*
* @param {Company_Companydetails_Address1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const company_companydetails_address1 = /** @type {((inputs?: Company_Companydetails_Address1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Companydetails_Address1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_company_companydetails_address1(inputs)
	return en_company_companydetails_address1(inputs)
});
export { company_companydetails_address1 as "company_companyDetails_address" }